/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Understanding Charts", description = "Learn what how to configure, save, and update charts", lastUpdatedDate = new Date(1720742400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Understanding Charts",
        description: "Learn what how to configure, save, and update charts",
        lastUpdatedDate: "Fri Jul 12 2024 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: []
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      img: "img",
      ul: "ul",
      li: "li",
      strong: "strong"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Campaign Intelligence is available as an add-on on ", _jsx(_components.a, {
            href: "https://hightouch.com/pricing",
            children: "Business tier\nplans"
          }), "."]
        })
      }), "\n", _jsx(_components.p, {
        children: "Charts are the building blocks of Campaign Intelligence. We currently support 5 chart types and are always adding more. While the analysis varies between chart types, the general anatomy stays consisent across them."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "campaign-intel/anatomy_chart.png",
          alt: "Chart Anatomy"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Parent Model:"
          }), " The data set you want to perform your analysis over as defined in the schema setup step."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Chart Type:"
          }), " The analysis type you would like to run (Performance, Breakdowns, Funnels, Tables, Experiments)."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Metrics:"
          }), " An aggregation over events. Metrics can have an aggregation type, filters, and an attribution window. Metrics can be on the cohort level (sum of purchases for all users) or on the user level (average purchase amount per user)."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Audiences:"
          }), " The segment of users you want to include in the analysis. The default option is to include the entire parent model. You have the option to select multiple exisiting audiences or create adhoc inline audiences. If using an attribution window, events are only included if the user falls within the attribution window for the audience-metric pair."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Group by:"
          }), " The dimension to breakdown a metric by. There are 2 types of dimensions:", "\n", _jsxs(_components.ul, {
            children: ["\n", _jsx(_components.li, {
              children: "User Propertes: Attributes, traits, or merge columns of a user. Examples: gender, state, loyalty status"
            }), "\n", _jsx(_components.li, {
              children: "Event Properties: Attributes on the specfic event. Examples: brand, campaign, utms."
            }), "\n"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Time Interval:"
          }), " The time grain to roll up your metric by (daily, weekly, monthly). For example, sessions from distinct users per day would be DAU (daily active users) or sessions from distinct users per week would be WAU (weekly active users)."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Time Window:"
          }), " The time period you want to perform your analysis over. Events occuring outside this window will not contribute to the selected metrics."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Saved Charts:"
          }), " A drawer to see all saved charts across the workspace."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Manage Metrics:"
          }), " A view to see a list of all saved metrics. From this view, you can create, edit, or delete existing metrics."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
